import { TDay, THours } from '../types'

interface IShiftRowData {
  label: string
  value: string
}

const dayAbbreviations: Record<NonNullable<TDay>, string> = {
  monday: 'Mon',
  tuesday: 'Tues',
  wednesday: 'Wed',
  thursday: 'Thurs',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun',
}

/**
 * @description Get a list of shift schedules as `label` (day-of-week)/`value` (time range) pairs. If the hours for
 * Monday through Friday are the same, only return one rows to represent the hours for all weekdays, in addition to the
 * two rows for the weekend.
 */
export const getDedicatedLaneFacilityShiftRows = (facilityHours?: THours): IShiftRowData[] => {
  const { sameHoursMonFri, shifts } = facilityHours ?? {}

  let shiftsToDisplay = shifts ?? []

  if (sameHoursMonFri) {
    shiftsToDisplay = shiftsToDisplay.filter(({ day }) =>
      (['monday', 'saturday', 'sunday'] as TDay[]).includes(day!)
    )
  }

  return shiftsToDisplay.map(({ closed, day, endTime, startTime }) => ({
    label: sameHoursMonFri && day === 'monday' ? 'Mon-Fri' : dayAbbreviations[day!],
    value: closed ? 'Closed' : `${startTime} - ${endTime}`,
  }))
}
